export { UploadBody } from './Body';
export { UploadFooter } from './Footer';
export { UploadIcon } from './Icon';
export { UploadText } from './Text';
export { Upload } from './Upload';
